import React from "react";
import { useCookies } from "react-cookie";
import dayjs from "dayjs";
import "dayjs/locale/id";
import "dayjs/locale/en";

const BeritaCard = ({ item, href }) => {
    const [cookies] = useCookies(["i18next"]);

    const convertToSlug = (title) => {
        if (!title) return "";
        return title
            .toLowerCase()
            .trim()
            .replace(/[^\w\s-]/g, "")
            .replace(/\s+/g, "-")
            .replace(/-+/g, "-");
    };

    const formatDate = (date, locale = "en") => {
        return dayjs(date).locale(locale).format("DD MMMM YYYY");
    };

    const titleText = cookies.i18next === "id" ? item.title : item.title_en || item.title;
    const linkHref = href || `/berita-kegiatan/${btoa(item.id)}/${convertToSlug(item.title)}`;

    const renderTags = () => {
        let parsedTags = [];

        if (Array.isArray(item.tags)) {
            parsedTags = item.tags.map(t => t.value);
        } else if (item.tag && typeof item.tag === "string") {
            try {
                const jsonTags = JSON.parse(item.tag);
                if (Array.isArray(jsonTags)) {
                    parsedTags = jsonTags.map(t => t.value);
                } else {
                    parsedTags = item.tag.split(",");
                }
            } catch (e) {
                parsedTags = item.tag.split(",");
            }
        } else if (item.tags && typeof item.tags === "string") {
            try {
                const jsonTags = JSON.parse(item.tags);
                if (Array.isArray(jsonTags)) {
                    parsedTags = jsonTags.map(t => t.value);
                } else {
                    parsedTags = item.tags.split(",");
                }
            } catch (e) {
                parsedTags = item.tags.split(",");
            }
        }

        if (parsedTags.length === 0) return null;

        return parsedTags.slice(0, 2).map((tag, index) => (
            <span key={index} className="me-2">{tag && tag.trim() !== "" ? "#" + tag.trim() : ""}</span>
        ));
    };

    const resolveImageUrl = (path, type = 'news') => {
        if (!path || path === "") return '/assets/image/foto-beritas.png';
        if (path.startsWith('http://') || path.startsWith('https://')) return path;
        const cleanPath = path.startsWith('/') ? path : `/${path}`;
        if (cleanPath.startsWith('/assets/') || cleanPath.startsWith('/static/')) return cleanPath;
        if (path.includes('uploads/') || path.includes('storage/')) {
            const cmsUrl = process.env.REACT_APP_API_URL || 'https://cms.kneks.go.id';
            return `${cmsUrl.replace(/\/$/, '')}${cleanPath}`;
        }
        if (type === 'gallery') {
            const base = (process.env.REACT_APP_API_PHOTO_BERITA || 'https://cms.kneks.go.id/uploads/photo/').replace(/\/?$/, '/');
            return `${base}${path.replace(/^\//, '')}`;
        }
        const base = (process.env.REACT_APP_API_NEWS || 'https://cms.kneks.go.id/storage/news/').replace(/\/?$/, '/');
        return `${base}${path.replace(/^\//, '')}`;
    };

    // [MODIFIKASI] Menggunakan Regex untuk memotong URL pertama
    const getFirstImage = () => {
        const rawData = item?.image || item?.images || item?.foto_gallery?.[0]?.foto;

        if (!rawData) return '/assets/image/foto-beritas.png';

        const rawString = Array.isArray(rawData) ? rawData[0] : String(rawData);
        const type = (rawData === item?.foto_gallery?.[0]?.foto) ? 'gallery' : 'news';

        // Regex: Menghapus koma pertama dan semua karakter setelahnya
        const firstUrl = rawString.replace(/,.*/, '').trim();

        if (firstUrl) {
            return resolveImageUrl(firstUrl, type);
        }

        return '/assets/image/foto-beritas.png';
    };

    return (
        <div className="berita-card h-100 d-flex flex-column" style={{ borderRadius: "12px", overflow: "hidden", boxShadow: "0 4px 20px rgba(0,0,0,0.05)", transition: "all 0.3s ease", backgroundColor: "#fff", border: "1px solid #f0f0f0" }}>
            <div className="berita-card-imgbox position-relative" style={{ height: "200px", overflow: "hidden" }}>
                <a href={linkHref}>
                    <img
                        src={getFirstImage()}
                        onError={(e) => {
                            e.target.onerror = null;
                            e.target.src = `/assets/image/foto-beritas.png`;
                        }}
                        className="img-fluid w-100 h-100"
                        style={{ objectFit: "cover", transition: "transform 0.5s ease" }}
                        alt={titleText}
                        onMouseOver={e => e.currentTarget.style.transform = "scale(1.05)"}
                        onMouseOut={e => e.currentTarget.style.transform = "scale(1)"}
                    />
                </a>
            </div>

            <div className="berita-content d-flex flex-column pt-3 px-3 pb-3 flex-grow-1 justify-content-between">
                <div className="flex-grow-1">
                    <div className="event-card-info-x mb-1" style={{ color: "#00994B", fontSize: "0.85rem", fontWeight: "600" }}>
                        {renderTags()}
                    </div>

                    <div className="event-card-title mb-1">
                        <h4 style={{ margin: 0 }}>
                            <a
                                href={linkHref}
                                style={{
                                    display: "-webkit-box",
                                    WebkitLineClamp: 3,
                                    WebkitBoxOrient: "vertical",
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                    fontSize: "1.1rem",
                                    fontWeight: "700",
                                    color: "#2b2b2b",
                                    textDecoration: "none",
                                    lineHeight: "1.3"
                                }}
                                onMouseOver={e => e.currentTarget.style.color = "#00994B"}
                                onMouseOut={e => e.currentTarget.style.color = "#2b2b2b"}
                            >
                                {titleText}
                            </a>
                        </h4>
                    </div>
                </div>

                <div className="event-card-info d-flex align-items-center text-muted mt-2" style={{ fontSize: "0.85rem", borderTop: "1px solid #f5f5f5", paddingTop: "6px" }}>
                    <i className="fa-regular fa-calendar me-2"></i>
                    <span>
                        {cookies.i18next === "id"
                            ? formatDate(item.news_datetime || item.hot_issue_datetime || item.created_at || item.date_created, "id")
                            : formatDate(item.news_datetime || item.hot_issue_datetime || item.created_at || item.date_created, "en")}
                    </span>
                </div>
            </div>
        </div>
    );
};

export default BeritaCard;